// PRODUCT_CATEGORY TYPES
const RegistrationTypesData = {
    INDIVIDUAL: 'Individual',
    COMPANY: 'Company'
};

export const REGISTRATION_TYPES = {};

export const REGISTRATION_TYPES_LIST = Object.keys(
    RegistrationTypesData,
).map((key) => {
    REGISTRATION_TYPES[key] = key;
    return {
        value: key,
        label: RegistrationTypesData[key],
    };
});

// Gender TYPES
const GenderTypesData = {
    MALE: 'Male',
    FEMALE: 'Female'
};
export const GENDER_TYPES = {};
export const GENDER_TYPES_LIST = Object.keys(
    GenderTypesData,
).map((key) => {
    GENDER_TYPES[key] = key;
    return {
        value: key,
        label: GenderTypesData[key],
    };
});
// Merrital TYPES
const MaritalTypesData = {
    MARRIED: 'Married',
    UNMARRIED: 'Unmarried'
};
export const MARITAL_TYPES = {};
export const MARITAL_TYPES_LIST = Object.keys(
    MaritalTypesData,
).map((key) => {
    MARITAL_TYPES[key] = key;
    return {
        value: key,
        label: MaritalTypesData[key],
    };
});





export default {
    REGISTRATION_TYPES_LIST,
    GENDER_TYPES_LIST,
    MARITAL_TYPES_LIST
};
